// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/LoadObservation.yaml
// Generated: 2026-10-19T08:02:07.523Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateLoadObservation, UpdateLoadObservation, LoadObservation } from '@/types/forestry/LoadObservation';

/**
 * LoadObservation Service
 * CRUD operations for LoadObservation via the ABP API.
 */
export const loadObservationService = new EntityService<LoadObservation, CreateLoadObservation, UpdateLoadObservation>(
  '/api/forestry/loadobservation',
  'LoadObservation',
);
